/* Copyright (C) 2019 SplendidCRM Software, Inc. All Rights Reserved. 
 * Any use of the contents of this file are subject to the SplendidCRM Professional Source Code License Agreement, or other written agreement between you and SplendidCRM ("License"). 
 * SplendidCRM owns all proprietary rights, including all copyrights, patents, trade secrets, and trademarks, in and to the contents of this file.  You will not link to or in any way 
 * combine the contents of this file or any derivatives with any Open Source Code in any manner that would require the contents of this file to be made available to any third party. 
 */

// 1. React and fabric. 
import * as React from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
// 2. Store and Types. 
// 3. Scripts. 
// 4. Components and Views. 

interface IPlaceholderViewProps extends RouteComponentProps<any>
{
	MODULE_NAME: string;
	SUB_TITLE  : string;
	ID         : string;
}

class PlaceholderView extends React.Component<IPlaceholderViewProps>
{
	constructor(props: IPlaceholderViewProps)
	{
		super(props);
		this.state =
		{
		}
	}

	public render() {
		const { MODULE_NAME, SUB_TITLE, ID } = this.props;
		return (
			<div>
				Placeholder
			</div>
		);
	}
}

export default withRouter(PlaceholderView);
